<div class="ch-root">

  <!-- Topbar zone – mirrors the canvas-home topbar so the export button sits
       in the same container column as the Map/Charts toggle. -->
  <div class="ch-topbar">
    <div class="ch-topbar__container">
      <div class="ch-export">
        <button
          class="ch-export-btn"
          [class.ch-export-btn--enabled]="selectedDataset() !== null"
          [class.ch-export-btn--open]="isExportDropdownOpen()"
          type="button"
          [disabled]="selectedDataset() === null"
          title="Export chart"
          (click)="onExportTriggerClick()"
          [attr.aria-expanded]="isExportDropdownOpen()"
          aria-haspopup="dialog"
        >
          <svg width="13" height="13" viewBox="0 0 24 24" fill="none" aria-hidden="true">
            <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <polyline points="7 10 12 15 17 10" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <line x1="12" y1="15" x2="12" y2="3" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
          </svg>
          Export Chart
          <svg width="11" height="11" viewBox="0 0 24 24" fill="none" aria-hidden="true"
               [style.transform]="isExportDropdownOpen() ? 'rotate(180deg)' : 'none'"
               style="transition: transform 0.15s">
            <path d="M6 9l6 6 6-6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>

        <div
          class="ch-export__panel"
          *ngIf="isExportDropdownOpen() && selectedDataset()"
          role="dialog"
          aria-label="Export chart formats"
        >
          <div class="ch-export__formats" role="radiogroup" aria-label="Export format">
            <button
              type="button"
              class="ch-export__row"
              role="radio"
              (click)="selectExportFormat('json')"
              [attr.aria-checked]="exportFormat() === 'json'"
            >
              <span class="ch-export__radio" [class.ch-export__radio--on]="exportFormat() === 'json'">
                <span class="ch-export__radio-dot" *ngIf="exportFormat() === 'json'"></span>
              </span>
              <span class="ch-export__label">json</span>
            </button>
            <button
              type="button"
              class="ch-export__row"
              role="radio"
              (click)="selectExportFormat('png')"
              [attr.aria-checked]="exportFormat() === 'png'"
              [disabled]="!canExportImage()"
              [title]="canExportImage() ? 'Export chart as PNG image' : 'Load chart data before exporting as PNG'"
            >
              <span class="ch-export__radio" [class.ch-export__radio--on]="exportFormat() === 'png'">
                <span class="ch-export__radio-dot" *ngIf="exportFormat() === 'png'"></span>
              </span>
              <span class="ch-export__label">png</span>
            </button>
            <button
              type="button"
              class="ch-export__row"
              role="radio"
              (click)="selectExportFormat('jpeg')"
              [attr.aria-checked]="exportFormat() === 'jpeg'"
              [disabled]="!canExportImage()"
              [title]="canExportImage() ? 'Export chart as JPEG image' : 'Load chart data before exporting as JPEG'"
            >
              <span class="ch-export__radio" [class.ch-export__radio--on]="exportFormat() === 'jpeg'">
                <span class="ch-export__radio-dot" *ngIf="exportFormat() === 'jpeg'"></span>
              </span>
              <span class="ch-export__label">jpeg</span>
            </button>
          </div>
          <button
            type="button"
            class="ch-export__cta"
            [disabled]="!canSubmitExport()"
            (click)="submitChartExport()"
          >
            Export Chart
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Welcome state — shown before any dataset is added -->
  <div class="ch-welcome" *ngIf="!hasDatasets()">
    <div class="ch-welcome__content">
      <div class="ch-welcome__illustration" aria-hidden="true">
        <svg width="180" height="140" viewBox="0 0 180 140" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="8" y="8" width="164" height="124" rx="12" fill="var(--canvas-primary-bg-soft)"/>
          <line x1="28" y1="108" x2="152" y2="108" stroke="var(--canvas-border-muted)" stroke-width="1.5" stroke-linecap="round"/>
          <rect x="36" y="72" width="16" height="36" rx="3" fill="var(--canvas-primary)" opacity="0.85"/>
          <rect x="60" y="56" width="16" height="52" rx="3" fill="var(--canvas-shape-rectangle)"/>
          <rect x="84" y="44" width="16" height="64" rx="3" fill="var(--canvas-action)"/>
          <rect x="108" y="60" width="16" height="48" rx="3" fill="var(--canvas-shape-rectangle)" opacity="0.75"/>
          <rect x="132" y="48" width="16" height="60" rx="3" fill="var(--canvas-primary)"/>
          <path d="M36 88 L60 68 L84 52 L108 72 L132 58 L148 46" stroke="var(--canvas-action)" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
          <circle cx="36" cy="88" r="4" fill="var(--canvas-surface)" stroke="var(--canvas-action)" stroke-width="2"/>
          <circle cx="60" cy="68" r="4" fill="var(--canvas-surface)" stroke="var(--canvas-action)" stroke-width="2"/>
          <circle cx="84" cy="52" r="4" fill="var(--canvas-surface)" stroke="var(--canvas-action)" stroke-width="2"/>
          <circle cx="108" cy="72" r="4" fill="var(--canvas-surface)" stroke="var(--canvas-action)" stroke-width="2"/>
          <circle cx="132" cy="58" r="4" fill="var(--canvas-surface)" stroke="var(--canvas-action)" stroke-width="2"/>
          <circle cx="148" cy="46" r="4" fill="var(--canvas-surface)" stroke="var(--canvas-action)" stroke-width="2"/>
        </svg>
      </div>
      <h2 class="ch-welcome__title">Visualize your datasets</h2>
      <p class="ch-welcome__text">
        Add datasets to visualize charts and explore your data.
      </p>
      <button
        class="ch-welcome__add-btn"
        type="button"
        (click)="openDatasetsModal()"
      >
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" aria-hidden="true">
          <path d="M12 5v14M5 12h14" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
        </svg>
        Add Dataset
      </button>
    </div>
  </div>

  <!-- Two-column layout — shown once at least one dataset is added -->
  <div class="ch-layout" *ngIf="hasDatasets()">

    <!-- Left sidebar -->
    <aside class="ch-sidebar">
      <div class="ch-sidebar__header">
        <div class="ch-sidebar__search">
          <svg class="ch-sidebar__search-icon" width="14" height="14" viewBox="0 0 24 24" fill="none" aria-hidden="true">
            <circle cx="11" cy="11" r="7" stroke="currentColor" stroke-width="1.5"/>
            <path d="M16.5 16.5L21 21" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
          </svg>
          <input
            class="ch-sidebar__search-input"
            type="text"
            placeholder="Search datasets"
            [value]="searchQuery()"
            (input)="onSearch($event)"
            aria-label="Search datasets"
          />
        </div>
        <button class="ch-sidebar__add-btn" type="button" (click)="openDatasetsModal()">
          <svg width="13" height="13" viewBox="0 0 24 24" fill="none" aria-hidden="true">
            <path d="M12 5v14M5 12h14" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
          </svg>
          Add Dataset
        </button>
      </div>

      <ul
        class="ch-sidebar__list"
        role="listbox"
        aria-label="Selected datasets"
      >
        <li
          *ngFor="let d of filteredDatasets()"
          class="ch-sidebar__item"
          [class.ch-sidebar__item--active]="selectedId() === d.id"
          role="option"
          [attr.aria-selected]="selectedId() === d.id"
          (click)="selectDataset(d.id)"
        >
          <span
            class="ch-sidebar__item-name"
            [attr.title]="d.fullName"
          >{{ d.fullName }}</span>
          <span class="ch-sidebar__item-actions" (click)="$event.stopPropagation()">
            <button
              type="button"
              class="ch-sidebar__icon-btn ch-sidebar__icon-btn--external"
              title="Open dataset in catalogue"
              aria-label="Open dataset in catalogue"
              (click)="openDatasetInCatalogue(d, $event)"
            >
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"/>
                <polyline points="15 3 21 3 21 9" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"/>
                <line x1="10" y1="14" x2="21" y2="3" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </button>
            <button
              type="button"
              class="ch-sidebar__icon-btn ch-sidebar__icon-btn--delete"
              title="Remove from charts"
              aria-label="Remove from charts"
              (click)="removeDatasetFromCharts(d, $event)"
            >
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                <polyline points="3 6 5 6 21 6" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"/>
                <line x1="10" y1="11" x2="10" y2="17" stroke="currentColor" stroke-width="1.75" stroke-linecap="round"/>
                <line x1="14" y1="11" x2="14" y2="17" stroke="currentColor" stroke-width="1.75" stroke-linecap="round"/>
              </svg>
            </button>
          </span>
        </li>

        <li class="ch-sidebar__empty" *ngIf="filteredDatasets().length === 0">
          No datasets found
        </li>
      </ul>
    </aside>

    <!-- Main content area -->
    <main class="ch-main">

      <!-- Empty state (datasets added but none selected) -->
      <div class="ch-empty" *ngIf="!selectedDataset()">
        <span class="ch-empty__text">Select a dataset to view charts</span>
      </div>

      <!-- Chart view (dataset selected) -->
      <div class="ch-chart-view" *ngIf="selectedDataset()">

        <!-- Dataset title + time filter dropdown -->
        <div class="ch-chart-header">
          <h2
            class="ch-chart-title"
            [attr.title]="selectedDataset()!.fullName"
          >{{ selectedDataset()!.fullName }}</h2>

          <!-- ── Time filter dropdown ──────────────────────────────────── -->
          <div class="ch-time-filter" (click)="$event.stopPropagation()">
            <button
              class="ch-time-filter__trigger"
              type="button"
              (click)="toggleTimeFilterOpen()"
              [attr.aria-expanded]="isTimeFilterOpen()"
              aria-haspopup="listbox"
              aria-label="Time range filter"
            >
              {{ timeFilterLabel() }}
              <svg width="12" height="12" viewBox="0 0 24 24" fill="none" aria-hidden="true"
                   [style.transform]="isTimeFilterOpen() ? 'rotate(180deg)' : 'none'"
                   style="transition: transform 0.15s">
                <path d="M6 9l6 6 6-6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </button>

            <div class="ch-time-filter__dropdown" *ngIf="isTimeFilterOpen()" role="listbox" aria-label="Time range options">
              <div class="ch-time-filter__presets">
                <button
                  type="button"
                  class="ch-time-filter__option"
                  [class.ch-time-filter__option--active]="selectedTimeFilter() === '24h'"
                  role="option"
                  [attr.aria-selected]="selectedTimeFilter() === '24h'"
                  (click)="selectTimeFilter('24h')"
                >Last 24 Hrs</button>
                <button
                  type="button"
                  class="ch-time-filter__option"
                  [class.ch-time-filter__option--active]="selectedTimeFilter() === '7d'"
                  role="option"
                  [attr.aria-selected]="selectedTimeFilter() === '7d'"
                  (click)="selectTimeFilter('7d')"
                >Last Week</button>
                <button
                  type="button"
                  class="ch-time-filter__option"
                  [class.ch-time-filter__option--active]="selectedTimeFilter() === '30d'"
                  role="option"
                  [attr.aria-selected]="selectedTimeFilter() === '30d'"
                  (click)="selectTimeFilter('30d')"
                >Last Month</button>
                <button
                  type="button"
                  class="ch-time-filter__option"
                  [class.ch-time-filter__option--active]="selectedTimeFilter() === 'custom'"
                  role="option"
                  [attr.aria-selected]="selectedTimeFilter() === 'custom'"
                  (click)="selectTimeFilter('custom')"
                >Custom Range</button>
              </div>

              <!-- Custom date range — project date-range-picker -->
              <div class="ch-time-filter__custom" *ngIf="selectedTimeFilter() === 'custom'">
                <lib-charts-date-range-picker
                  [ngModel]="customDateRange()"
                  (ngModelChange)="onCustomDateRangeChange($event)"
                  placeholder="Choose Date Range"
                  styleClass="ch-time-filter__date-picker"
                  [disableFutureDates]="false"
                  [overlayOnTrigger]="true"
                ></lib-charts-date-range-picker>
                <button
                  class="ch-time-filter__apply-btn"
                  type="button"
                  [disabled]="!canApplyCustomRange()"
                  (click)="applyCustomRange()"
                >Apply</button>
              </div>
            </div>
          </div>
          <!-- ── /Time filter dropdown ─────────────────────────────────── -->
        </div>

        <!-- Chart controls -->
        <div class="ch-chart-controls">

          <!-- Chart Type -->
          <div class="ch-chart-control ch-chart-type" (click)="$event.stopPropagation()">
            <span class="ch-chart-control__label">Chart Type</span>
            <button
              class="ch-chart-control__select"
              type="button"
              (click)="toggleChartTypeOpen()"
              [attr.aria-expanded]="isChartTypeOpen()"
              aria-haspopup="listbox"
              aria-label="Chart type"
              [disabled]="availableChartTypes().length === 0"
            >
              {{ chartTypeLabel() }}
              <svg width="12" height="12" viewBox="0 0 24 24" fill="none" aria-hidden="true"
                   [style.transform]="isChartTypeOpen() ? 'rotate(180deg)' : 'none'"
                   style="transition: transform 0.15s">
                <path d="M6 9l6 6 6-6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </button>
            <div class="ch-chart-type__panel" *ngIf="isChartTypeOpen()" role="listbox" aria-label="Chart type options">
              <button
                *ngFor="let ct of availableChartTypes()"
                type="button"
                class="ch-chart-type__row"
                [class.ch-chart-type__row--active]="activeSchemaIndex() === ct.idx"
                role="option"
                [attr.aria-selected]="activeSchemaIndex() === ct.idx"
                (click)="selectChartKind(ct.idx)"
              >
                <span>{{ ct.label }}</span>
                <svg *ngIf="ct.kind === 'line'" class="ch-chart-type__icon" width="22" height="22" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                  <path d="M4 18 L8 12 L12 16 L16 8 L20 14" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                <svg *ngIf="ct.kind === 'bar'" class="ch-chart-type__icon" width="22" height="22" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                  <rect x="5" y="14" width="4" height="6" rx="0.5" stroke="currentColor" stroke-width="1.5"/>
                  <rect x="10" y="10" width="4" height="10" rx="0.5" stroke="currentColor" stroke-width="1.5"/>
                  <rect x="15" y="6" width="4" height="14" rx="0.5" stroke="currentColor" stroke-width="1.5"/>
                </svg>
              </button>
            </div>
          </div>

          <!-- X-Axis (display only — fixed per schema) -->
          <div class="ch-chart-control">
            <span class="ch-chart-control__label">X-Axis</span>
            <div class="ch-chart-control__select ch-chart-control__select--readonly">
              {{ xAxisLabel() }}
            </div>
          </div>

          <!-- Y-Axis (dropdown to select field) -->
          <div class="ch-chart-control ch-y-axis" (click)="$event.stopPropagation()">
            <span class="ch-chart-control__label">Y-Axis</span>
            <button
              class="ch-chart-control__select"
              type="button"
              (click)="toggleYAxisOpen()"
              [attr.aria-expanded]="isYAxisOpen()"
              aria-haspopup="listbox"
              [disabled]="activeSchema()?.plotType === 'multiLinePlot'"
              aria-label="Y-Axis field"
            >
              {{ currentYFieldLabel() }}
              <svg *ngIf="activeSchema()?.plotType !== 'multiLinePlot'"
                   width="12" height="12" viewBox="0 0 24 24" fill="none" aria-hidden="true"
                   [style.transform]="isYAxisOpen() ? 'rotate(180deg)' : 'none'"
                   style="transition: transform 0.15s">
                <path d="M6 9l6 6 6-6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </button>
            <div class="ch-chart-type__panel" *ngIf="isYAxisOpen()" role="listbox" aria-label="Y-Axis field options">
              <button
                *ngFor="let field of yAxisOptions()"
                type="button"
                class="ch-chart-type__row"
                [class.ch-chart-type__row--active]="currentYFieldLabel() === field"
                role="option"
                [attr.aria-selected]="currentYFieldLabel() === field"
                (click)="selectYField(field)"
              >
                {{ field }}
              </button>
            </div>
          </div>

        </div>

        <!-- Chart area -->
        <div class="ch-chart-area">

          <!-- Loading state -->
          <div class="ch-chart-loader" *ngIf="chartLoading()">
            <span class="ch-chart-loader__spinner" aria-hidden="true"></span>
            <span class="ch-chart-loader__text">Loading chart data…</span>
          </div>

          <!-- No data state (loaded but empty) -->
          <div class="ch-chart-empty" *ngIf="!chartLoading() && !echartsOption()">
            <span class="ch-empty__text">No chart data available for this duration</span>
          </div>

          <!-- ECharts container -->
          <div
            *ngIf="!chartLoading() && echartsOption()"
            echarts
            [options]="echartsOption()!"
            (chartInit)="onChartInit($event)"
            class="ch-echarts-container"
            aria-label="Chart"
          ></div>

        </div>

      </div>
    </main>

  </div>

</div>

<!-- Datasets picker modal for charts -->
<lib-charts-datasets-modal
  [isOpen]="isDatasetsModalOpen()"
  (closeModal)="isDatasetsModalOpen.set(false)"
  (datasetSelected)="onDatasetSelected($event)"
></lib-charts-datasets-modal>
